<template>
  <div class="privacy-policy">
    <div class="container">
      <span class="version">v: {{version}}</span>
      <div class="links">
        <router-link :to="`/privacy-policy`">{{$ml.get('Privacy Policy')}}</router-link>
        <span>|</span>
        <router-link :to="`/license-terms`">{{$ml.get('Terms & Conditions')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      version: 'misc/getVersion'
    })
  }
}
</script>

<style lang="scss" scoped>

.privacy-policy {

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  
  border-top: 1px solid #E4E5E6;
  width: 100%;
  background: #fff;
  height: 40px;
  z-index: 1;
  
  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    .version {
      font-size: 12px;
      color: #999;
      margin-left: 16px;
    }
  }

  a {
    padding: 0 16px;
    font-size: 12px;
  }

  span {
    color: #e0e0e0;
  }
}

</style>